import React from 'react';

import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import {
  VideoSessionOutputDTO,
  CardHcd,
} from '@maiia/model/generated/model/api-patient/api-patient';
import {
  useMediaQueryBreakPoint,
  IS_PHONE_OR_TABLET,
} from '../../../src/hooks';
import SearchCardAssembled from './SearchCardAssembled';
import SearchCardDeepLink from './SearchCardDeepLink';
import { ListMode } from '../SearchResults/types';
import { checkVideoStatusIs } from '@/components/templates/TlcSession/utils';

type AppState = {
  videoSessions: {
    items: VideoSessionOutputDTO[];
  };
};

interface Props {
  className?: string;
  mode?: ListMode;
  item: Required<CardHcd>;
  ref?: React.RefObject<unknown>;
  onClick?: React.ReactEventHandler;
}

// TODO cristella this is a molecule

const waitingVideoSessionsSelector = createSelector(
  (state: AppState) =>
    state?.videoSessions?.items?.filter(videoSession =>
      checkVideoStatusIs(videoSession.videoSessionStatus, [
        'PENDING',
        'WAITING',
        'STARTED',
      ]),
    ),
  items => items,
);

const SearchCard = React.forwardRef<HTMLDivElement, Props>(
  ({ className, mode, item, onClick }, ref) => {
    const isPhoneOrTablet: boolean = useMediaQueryBreakPoint(
      IS_PHONE_OR_TABLET,
    );

    const waitingVideoSessions = useSelector(
      waitingVideoSessionsSelector,
      (left, right) =>
        left.length === 0 && right.length === 0 ? true : left === right, // <- WRONG
    );

    const withTheSamePractitioner =
      waitingVideoSessions?.filter(
        videoSession =>
          videoSession.practitionerId === item.professional?.practitionerId &&
          videoSession.centerId === item.center.id,
      ).length > 0;

    return (
      <SearchCardDeepLink
        enabled={mode === 'tlc' && isPhoneOrTablet}
        item={item}
      >
        <SearchCardAssembled
          ref={ref}
          mode={mode}
          item={item}
          className={className}
          waitingVideoSessions={waitingVideoSessions}
          withTheSamePractitioner={withTheSamePractitioner}
          onClick={onClick}
        />
      </SearchCardDeepLink>
    );
  },
);

SearchCard.displayName = 'SearchCard';

export default React.memo(
  SearchCard,
  (oldProps, newProps) => oldProps.item.id === newProps.item.id,
);
